











































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import RateCardDto from '@/models/RateCards/RateCardDto'
import AgencyRateCardPositions from '@/components/RateCardPositions/AgencyRateCardPositions.vue';
import AgencyRateCardCreate from '@/components/RateCards/AgencyRateCardCreate.vue';
import AgencyRateCardEdit from '@/components/RateCards/AgencyRateCardEdit.vue';

@Component({
  name: 'AgencyRateCards',
  components: { AgencyRateCardPositions, AgencyRateCardCreate, AgencyRateCardEdit }
})
export default class extends Vue {
    
    async beforeMount() {
        AgencySettingsModule.updateCurrentRateCard(null);
    }

    async updateRateCard(rateCard: RateCardDto) {
        AgencySettingsModule.updateCurrentRateCard(rateCard);
    }

    get currentRateCard() {
        return AgencySettingsModule.currentRateCard;
    }

    get loadingRateCards() {
        return AgencySettingsModule.loadingRateCards;
    }

    get rateCards() {
        return AgencySettingsModule.rateCards;
    }
}
